/* istanbul ignore file */
import { MultiSelectInputFilter, ConditionProps } from 'framework/list';
import { MultiSelectField } from 'domain/shared/core/input';
import { useEmployeeSuggestionsService, buildEmployeeAutoSuggestLabel } from 'domain/shared/employee';

const EmployeeMultiSelectFilter = ({ label, ...props }: Omit<ConditionProps, 'children'> & { label: string }) => {
  return (
    <MultiSelectInputFilter {...props}>
      <MultiSelectField
        {...props}
        label={label}
        useService={useEmployeeSuggestionsService}
        noOptionLabel="Worker"
        buildLabelCallback={buildEmployeeAutoSuggestLabel}
      />
    </MultiSelectInputFilter>
  );
};

export default EmployeeMultiSelectFilter;
